<template>
  <div class="withdrawalProcess_warpper">
    <nav-bar titleText="申请结果" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="contentBox">
      <div class="stepsBody van-hairline--bottom">
        <div class="stepsBox" v-for="(item, index) in stepsData" :key="index">
          <van-row type="flex" class="stepsBox_row">
            <van-col span="3">
              <div :class="item.actived ? '' : 'marLe8'">
                <p :class="item.actived ? 'active_icon' : 'small_icon'">
                  <img :src="item.img" width="100%" height="100%" />
                </p>
                <!-- <div v-if="index!==stepsData.length-1" :class="item.title =='through' ? 'solid_line' : item.title =='notAudit' ? 'dotted_line marLe8':'dotted_line marLe16'" ></div> -->
                <div v-if="index!==stepsData.length-1" :class="item.line" ></div>
              </div>
            </van-col>
            <van-col span="21">
              <p :class="item.actived ? item.time ? 'activeText' : 'activeText marT8-5' : 'steps_title' " >{{item.text}}</p>
              <p :class=" item.actived ? 'status_time_2' : 'status_time_1'">{{item.time}}</p>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="detail">                  
        <van-row class="detail_row">
          <van-col span="12">
            <p class="withdrawal_title">提现金额</p>
          </van-col>
          <van-col span="12" class="detail_left_col">
            <p>¥{{ money }}</p>
          </van-col>
        </van-row>
        <van-row class="detail_row">
          <van-col span="12">
            <p class="withdrawal_title">到账银行卡</p>
          </van-col>
          <van-col span="12" class="detail_left_col">
            <p>{{ bankInfo }}</p>
          </van-col>
        </van-row>
        <van-row class="detail_row">
          <van-col span="12">
            <p class="withdrawal_title">编号</p>
          </van-col>
          <van-col span="12" class="detail_left_col">
            <p>{{ordersn}}</p>
          </van-col>
        </van-row>
        <van-row class="detail_row" v-if="this.isFailed">
          <van-col span="12">
            <p class="withdrawal_title">驳回原因</p>
          </van-col>
          <van-col span="12" class="detail_left_col">
            <p>{{ remark }}</p>
          </van-col>
        </van-row>
        <div class="btn-box">
          <van-button type="primary" class="withdrawal_btn" @click="goBack">返回</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  name: "withdrawalProcess",
  data() {
    return {
      stepsData: [
        {
          actived: false,
          img: require("../../../assets/debtor/sccess.png"),
          line: '',
          text: "发起提现申请",
        },
        {
          actived: false,
          img: require("../../../assets/debtor/inProcess.png"),
          line: '',
          // title: "notAudit",
          text: "处理中",
        },
        {
          actived: false,
          img: require("../../../assets/debtor/sccess.png"),
          line: '',
          text: "提现成功",
          time: "",
        },
      ],
      success: false,
      bankInfo: '',
      money: '',
      remark: '',
      isFailed: false,
      ordersn:'',
      accountId:'',
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo()
  },
  mounted() {
    this.deduceLine()
  },
  components: {
    navBar,
  },
  methods: {
    getInfo(){
      this.$api.post('/debt/member/withdrawal/withdrawal/detail', {
        // TODO
        // ordersn: "832003251629096561",
        id: this.$route.query.id,
      })
      .then(data => {
        let lastNumber = data.card.accountNo
        // this.accountId = data.accountId
        if (/^\d+$/.test(lastNumber)) {
          // 全数字 银行卡号 取最后4位
          lastNumber = `尾号${lastNumber.slice(-4)}`
        }
        if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(lastNumber)) {
          // TODO
          // 邮箱  说明是支付宝？ 这种该怎么处理？ 这里暂时取前6位 + ***
          lastNumber = lastNumber.slice(0,6) + '***'
        }
        this.bankInfo = `${data.card.channelName} ${lastNumber}`
        this.money = data.withdrawal_amount
        this.remark = data.reject_season
        this.ordersn = data.withdrawal_sn
        // data.status = 'refused'
        // 已创建
        if ([0].includes(data.status)) {
          this.stepsData[1].actived = true
          this.stepsData[2].img = require("../../../assets/debtor/beforeProcess.png")
        }
        // 成功
        if (data.status == 1) {
          this.stepsData[2].actived = true
          this.stepsData[1].img = require("../../../assets/debtor/sccess.png")
          this.stepsData[2].img = require("../../../assets/debtor/sccess.png")
          this.stepsData[2].time = data.updateTime
        }
        // 驳回
        if (data.status == -1) {
          this.isFailed = true
          this.stepsData[2].actived = true
          this.stepsData[1].img = require("../../../assets/debtor/sccess.png")
          this.stepsData[2].img = require("../../../assets/debtor/failed.png")
          this.stepsData[2].text = '提现失败'
          this.stepsData[2].time = data.updateTime
        }

        this.deduceLine()
      })
      .catch(err => {
        this.$toast(err.message)
      })
    },
    deduceLine(){
      let line = false
      this.stepsData.forEach(item => {
        if (item.actived) {
          line = true
        }
        if (line) {
          item.line = item.actived ? 'dotted_line marLe16' : 'dotted_line marLe8'
          return
        }
        item.line = item.actived ? 'solid_line marLe17' : 'solid_line'
      })
    },
    goBack(){
      this.$router.push({
        path:'/agent/myCommission',
        query:{
          token:localStorage.getItem('_token') || this.$route.query.token,
          // account_id:this.accountId,
          debt_from: 'commissonResult',
        }
      })
    }
  },
};
</script>
<style lang="less">
.withdrawalProcess_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  height: 100%;
  color: #333;
  font-size: 14px;
  .contentBox {
    width: 100%;
    background: #fff;
    padding-bottom: 20px;
    .stepsBody {
      margin: 12px 33px 0;
      padding: 36px 0 30px;
      font-size: 16px;
      .stepsBox {
        .small_icon {
          width: 20px;
          height: 20px;
        }
        .solid_line {
          height: 50px;
          margin-left: 9px;
          border-left: 2px solid #f9591b;
        }
        .steps_title {
          color: #999;
          font-size: 15px;
          margin-top: 1px;
        }
        .activeText {
          margin: 1px 0 0 10px;
          font-size: 15px;
        }
        .active_icon {
          width: 36px;
          height: 36px;
        }
        .dotted_line {
          height: 50px;
          margin-left: 9px;
          border-left: 2px dotted #fdbda4;
        }
        .marLe8 {
          margin-left: 8px;
        }
        .marT8-5 {
          margin-top: 8.5px;
        }
        .marLe9 {
          margin-left: 9px;
        }
        .marLe16 {
          margin-left: 16px;
        }
        .marLe17 {
          margin-left: 17px;
        }
        .in_steps_title {
          margin-left: 10px;
        }
      }
      .status_time_1 {
        line-height: 21px;
        font-size: 13px;
        color: #999;
      }
      .status_time_2 {
        margin-left: 10px;
        line-height: 21px;
        font-size: 13px;
        color: #999;
      }
    }
    .detail {
      margin: 0 33px;
      padding: 36px 0;
      .detail_row {
        margin: 9px 0;
        line-height: 24px;
        font-size: 15px;
        &:nth-of-type(1) {
          margin-top: 0;
        }
      }
      
      .withdrawal_title {
        color: #999;
      }
      .btn-box {
        margin-top: 36px;
      }
      .withdrawal_btn {
        width: 100%;
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
        background: #fff;
        border: 1px solid #666666;
        color: #333;
        // margin: 30px 0 10px;
      }
      .detail_left_col {
        text-align: right;
      }
    }
  }
}
</style>





